import { months } from '@pages/WorkSchedule/data';
import years from '@pages/WorkSchedule/data/years.json';
import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const getMonthDays = (monthId: number, year: number) => {
  // Проверка на високосный год
  const isLeapYar =
    years.find((item: NWorkSchedule.Year) => item.year === year)?.isLeap ||
    false;
  const isFeburary = monthId === 1;
  if (isLeapYar && isFeburary) {
    return 29;
  }

  // Основной сценарий
  return months.find((item: NWorkSchedule.Month) => item.monthId === monthId)
    ?.daysInMonth;
};
